module.exports = __webpack_public_path__ + "static/media/12.cbfe11f7.jpg";